import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceDetectorService {
  private userAgent = navigator.userAgent || navigator.vendor;

  isMobile(): boolean {
    return /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(this.userAgent.toLowerCase());
  }

  isTablet(): boolean {
    return /ipad|tablet|(android(?!.*mobile))/i.test(this.userAgent.toLowerCase());
  }

  isDesktop(): boolean {
    return !this.isMobile() && !this.isTablet();
  }

  getDeviceType(): 'mobile' | 'tablet' | 'desktop' {
    if (this.isMobile()) return 'mobile';
    if (this.isTablet()) return 'tablet';
    return 'desktop';
  }
}
